/**
* @summary - Component that Provides PDM SCHEDULE functionality
* @autor vengateshwaran k
* @since 2024-06-21
*/
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router";
import commonMasterRepository from "../../api/repositories/commonMasterRepository";
import PpmPlannerRepository from '../../api/repositories/ppmPlannerRepository';
import { DefaultCard } from "../../assets/styled-components/card";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import commonMessages from '../../utility/constant';
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDialog from '../commoncomponents/CustomDialog';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import CustomDatePicker from "../commoncomponents/CustomDatePicker";
import ActionButtons from "../commoncomponents/ActionButtons";
import ReArrangeLabel from "../../components/commoncomponents/ReArrangeLabel";
import PremitiveMaintenanceRepository from "../../api/repositories/premitiveMaintenanceRepository"
import {
  addDays,
  addMonths,
  addWeeks,
  endOfMonth,
  endOfYear,
  format,
  getDate,
  getMonth,
  getWeek,
  getYear,
  isBefore,
  parse,
  startOfDay,
} from "date-fns";
import PageLoader from "../commoncomponents/PageLoader";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
const PDMCreate = ({ getMode, facilityId, companyId, setPredictiveId, handleServiceType, assetNoForShowSchedule, taskCodeForShowSchedule, predictiveId, selectedYear }) => {

  const location = useLocation();
  const dispatch = useDispatch();
  const [serviceType, setServiceType] = useState(null);
  const [serviceTypeOptions, setServiceTypeOptions] = useState([]);
  const [year, setYear] = useState(null);
  const [yearOptions, setYearOptions] = useState([]);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [nextDate, setNextDate] = useState();
  const [assetTypeCode, setAssetTypeCode] = useState();
  const [assetTypeCodeDescription, setAssetTypeCodeDescription] = useState();
  const [userLocationCode, setUserLocationCode] = useState();
  const [userLocationDescription, setUserLocationDescription] = useState();
  const [model, setModel] = useState();
  const [manufacturer, setManufacturer] = useState();
  const [serialNo, setSerialNo] = useState();
  const [assetClassification, setAssetClassification] = useState();
  const [assetNo, setAssetNo] = useState();
  const [assetOptions, setAssetOptions] = useState();
  const [taskCodeOptions, setTaskCodeOptions] = useState();
  const [taskCode, setTaskCode] = useState();
  const [periodOptions, setPeriodOptions] = useState();
  const [period, setPeriod] = useState();
  const [assignee, setAssignee] = useState();
  const [assigneeOptions, setAssigneeOptions] = useState([]);
  const statusOptions = [{ label: "Active", id: 1, value: true, default: true }, { label: "In Active", id: 2, value: false, default: false }];
  const [status, setStatus] = useState(
    (location?.state?.mode === 'edit' || location?.state?.mode === 'view') ? statusOptions?.find((item) => item?.label === location?.state?.isactive) :
      statusOptions?.find((item) => item?.default === true));
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [scheduledFrequency, setScheduledFrequency] = useState(1);
  const [agreedDate, setAgreedDate] = useState();
  const [isAddNew, setIsAddNew] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [allTarcks, setAllTarcks] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [preventSaveDuplicateRecord, setPreventSaveDuplicateRecord] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenForAsset, setIsModalOpenForAsset] = useState(false);
  const [gridApi, setGridApi] = useState({});
  const [gridAPIS, setGridAPIS] = useState({});
  const [isInputChanged, setIsInputChanged] = useState({
    statusChanged: false,
    assigneeTaskCodeChanged: false,
    frequencyDatePeriodChanged: false
  });
  const [isStatusRIDetailsChanged, setIsStatusRIDetailsChanged] = useState(false);
  const [isAssigneeTaskCodeChanged, setIsAssigneeTaskCodeChanged] = useState(false);
  const [isFrequencyDateChanged, setIsFrequencyDateChanged] = useState(false);
  const [disableUpdateButton, setDisableUpdateButton] = useState(false);
  

  const handleAssetClick = (newValue) => {
    let label = newValue?.label?.split(" - ")[0];
    setAssetNo({ ...newValue, label: label });
    setIsChanged(true);

    if (newValue?.value === "") {
      setAssetTypeCode("");
      setAssetTypeCodeDescription("");
      setUserLocationCode("");
      setUserLocationDescription("");
      setModel("");
      setManufacturer("");
      setSerialNo("");
      setAssetClassification("");
    } else if (newValue?.label !== "") {
      setAssetTypeCode(newValue?.typecode);
      setAssetTypeCodeDescription(newValue?.typedescription);
      setUserLocationCode(newValue?.locationcode);
      setUserLocationDescription(newValue?.locationdesc);
      setManufacturer(newValue?.manufacturer);
      setModel(newValue?.model);
      setSerialNo(newValue?.serialno);
      setAssetClassification(newValue?.assetclassification);
      assetNoForShowSchedule({ ...newValue, label: newValue?.value });
      setErrors({ ...errors, assetNo: null });

    }
    // Close the modal after asset selection
    handleCloseModalForAsset();
  };
  const columns = [
    {
      headerName: 'Asset No',
      field: 'label',
      width: 150,
      cellRenderer: (params) => (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleAssetClick(params.data);
          }}
          style={{
            color: 'blue',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          {params.value}
        </a>
      ),
    },
    { headerName: 'Description', field: 'assetdesc', width: 200 },
    { headerName: 'Service', field: 'serviceName', width: 100, valueGetter: () => `${serviceType?.label}`, },
    { headerName: 'Location', field: 'locationdesc', width: 150 },

  ];

  const handleTaskCodeClick = (newValue) => {
    setTaskCode({ ...newValue, label: newValue?.value });
    setIsChanged(true);
    if (newValue?.label !== "") {
      taskCodeForShowSchedule(newValue?.value);
      setErrors({ ...errors, taskCode: null });
    }

    // Close the modal after asset selection
    handleCloseModal();
  };

  const columnsTaskCode = [
    {
      headerName: 'Task Code',
      field: 'label',
      width: 150,
      cellRenderer: (params) => (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleTaskCodeClick(params.data);
          }}
          style={{
            color: 'blue',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          {params.value}
        </a>
      ),
    },
    { headerName: 'Task Description', field: 'taskdesc', width: 200 },
    { headerName: 'Service', field: 'serviceName', width: 100, valueGetter: () => `${serviceType?.label}`, },
  ];
  const colDefs = [
    {
      headerName: "",
      children: [
        {
          field: "assetno", headerName: "Asset No",

        },
        {
          field: "assetdesc", headerName: "Asset Description",

        },
        {
          field: "taskcode", headerName: "Task Code",

        },
      ]
    },
    {
      headerName: "Schedule & Target Date Details",
      children: [
        {
          field: "scheduledfrequency", headerName: "Scheduled Frequency",
        },
        {
          field: "period", headerName: "Period",
        },
        {
          field: "targetdate", headerName: "Target Date",
        },
      ]
    },
    {
      headerName: "",
      children: [
        {
          field: "nextppmdate", headerName: "Next PPM Date",
        },
        {
          field: "respondtype", headerName: "Respond Type",
        },
      ]
    }
  ];


  const ReArrangeLabels = async (originalData, keyToRename, newKeyName) => {
    try {
      // Map over the original array and transform each object
      const rearrangedData = originalData?.map((item) => {
        // Destructure the item to extract the value of the key to rename
        const { [keyToRename]: originalValue, ...rest } = item;

        // Create a new object with the renamed key and other remaining properties
        return {
          [newKeyName]: String(originalValue), // Rename the key
          value: originalValue,
          ...rest, // Spread the remaining properties
        };
      });
      return rearrangedData;
    } catch (error) {
      console.error(error)
    }
  }
  const hasMounted = useRef(false);
  const fetchOptionsForAllField = async () => {
    try {
      getMode(location?.state?.mode);
      setErrors({});
      const responseMasters = await commonMasterRepository.getMasters(facilityId, companyId);
      setServiceTypeOptions(responseMasters);
      setServiceType(responseMasters?.find((item) => item?.label === location?.state.service) || responseMasters?.find((item) => item?.label === 'FEMS'))
      const maintanenceyear = await commonMasterRepository.getMaintanenceYear(facilityId);
      setYearOptions(maintanenceyear?.filter((item) => Number(item?.value) === new Date().getFullYear()));
      setYear(maintanenceyear?.find((item) => Number(item?.value) === new Date().getFullYear()) || maintanenceyear[0]);
      selectedYear(maintanenceyear?.find((item) => Number(item?.value) === new Date().getFullYear()) || maintanenceyear[0]);
      if (location?.state?.mode !== 'edit' && location?.state?.mode !== 'view') {
        const dropDownLists =
          await PpmPlannerRepository.ppmscheduleDropDownList(
            facilityId,
            companyId
          );
        const periodOptionsRearrange = await ReArrangeLabels(
          dropDownLists?.data?.femppmintervaltypes,
          "intervaltypedesc",
          "label"
        );
        setPeriodOptions(periodOptionsRearrange?.filter((item) => (item.label === "Weeks" || item.label === "Months")));
        setPeriod(
          periodOptionsRearrange?.find((item) => item?.label === "Weeks")
        );
        const assigneeList = await PremitiveMaintenanceRepository.getStaffDetails(facilityId);
        if (assigneeList?.status !== 'error') {
          setAssigneeOptions(assigneeList);
        }
      }
    }
    catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    if (!hasMounted.current) {
      fetchOptionsForAllField();
      hasMounted.current = true;
    }
  }, []);

  useEffect(() => {
    if (location.state.mode === "edit" || location.state.mode === "view") {
      setEdit();
    }

  }, [location.state])

  const setAssetNoField = async (assetNo) => {
    try {
      if (location.state?.service === 'BEMS') {
        const assetList = await PremitiveMaintenanceRepository.getBemsAssetNoDetails(facilityId);
        setAssetOptions(assetList);
        setAssetNo(assetList?.find((item) => item?.label === assetNo))
        assetNoForShowSchedule(assetList?.find((item) => item?.label === assetNo));
      }
      if (location.state?.service === 'FEMS') {
        const assetList = await PremitiveMaintenanceRepository.getAssetNoDetails(facilityId);
        setAssetOptions(assetList);
        setAssetNo(assetList?.find((item) => item?.label === assetNo))
        assetNoForShowSchedule(assetList?.find((item) => item?.label === assetNo));
      }
    }
    catch (error) {
      console.error(error);
    }

  }

  // In this Function ,To set all values for edit Mode
  const setEdit = async () => {

    try {
      if ((location.state?.mode === "edit" || location.state?.mode === "view") && location?.state?.predictiveId != undefined) {
        setLoading(true);
        if (location?.state?.service === "FEMS") {
          const scheduleTracksFems = await PremitiveMaintenanceRepository.getPDMShowSchedule(location?.state?.predictiveId);
          setAllTarcks(scheduleTracksFems?.data);
          await setAssetNoField(location?.state?.assetNo);
          setAgreedDate(format(new Date(location?.state?.agreeddate), 'dd/MM/yyyy'));
          setNextDate(location?.state?.targetdateChanged); //This is the Formatted Next target date
          // setNextDate(format(new Date(location?.state?.targetdateChanged), 'dd/MM/yyyy'));
          setScheduledFrequency(location?.state?.frequencyunit);
        } else {
          const scheduleTracksBems = await PremitiveMaintenanceRepository.getBemsPDMShowSchedule(location?.state?.predictiveId);
          setAllTarcks(scheduleTracksBems?.data);
          await setAssetNoField(location?.state?.assetNo);
          setAgreedDate(format(new Date(location?.state?.agreeddate), 'dd/MM/yyyy'));
          setNextDate(location?.state?.targetdateChanged); //This is the Formatted Next target date
          // setNextDate(format(new Date(location?.state?.targetdateChanged), 'dd/MM/yyyy'));
          setScheduledFrequency(location?.state?.frequencyunit);
        }
      }
    } catch (error) {
      console.error(error)
    }
    //   finally {
    //     setLoading(false);  // End loading after the data is fetched
    // }
  }

  const serviceTypeChange = useMemo(() => {
    const fetchOptions = async () => {
      try {
        if (location.state.mode === "create") {
          setLoading(true);
        }
        if (location.state.mode != 'create') {
          if (serviceType?.label === 'BEMS') {
            const assetNo = await PremitiveMaintenanceRepository.getBemsAssetNoDetails(facilityId);
            setAssetOptions(assetNo);
            handleServiceType(serviceType);
          }
          if (serviceType?.label === 'FEMS') {
            const assetNo = await PremitiveMaintenanceRepository.getAssetNoDetails(facilityId);
            setAssetOptions(assetNo);
            handleServiceType(serviceType);
          }
        } else {
          let resultArray = [];
          if (serviceType?.label === 'BEMS') {
            const assetNo = await PremitiveMaintenanceRepository.getBemsAssetNoDetails(facilityId);
            if (location?.state?.pdmList?.length > 0) {
              resultArray = assetNo
            } else {
              resultArray = assetNo
            }
            const dropDownLists =
              await PpmPlannerRepository.ppmscheduleDropDownList(
                facilityId,
                companyId
              );
            const periodOptionsRearrange = await ReArrangeLabels(
              dropDownLists?.data?.femppmintervaltypes,
              "intervaltypedesc",
              "label"
            );

            setAssetTypeCode("");
            setAssetTypeCodeDescription("");
            setUserLocationCode("");
            setUserLocationDescription("");
            setModel("");
            setManufacturer("");
            setSerialNo("");
            setAssetClassification("");
            setAssetNo({ label: '', value: '' });
            setTaskCode({ label: '', value: '' });
            setAssignee({ label: '', value: '' });
            setAgreedDate('');
            setNextDate('');
            setScheduledFrequency(1);
            setPeriod(periodOptionsRearrange?.find((item) => item.label === "Weeks"));
            setStatus(statusOptions?.find((item) => item?.default === true));

            setAssetOptions(resultArray);
            handleServiceType(serviceType);
          }
          if (serviceType?.label === 'FEMS') {
            const assetNo = await PremitiveMaintenanceRepository.getAssetNoDetails(facilityId);
            if (location?.state?.pdmList?.length > 0) {
              resultArray = assetNo
            } else {
              resultArray = assetNo
            }
            const dropDownLists =
              await PpmPlannerRepository.ppmscheduleDropDownList(
                facilityId,
                companyId
              );
            const periodOptionsRearrange = await ReArrangeLabels(
              dropDownLists?.data?.femppmintervaltypes,
              "intervaltypedesc",
              "label"
            );
            setAssetTypeCode("");
            setAssetTypeCodeDescription("");
            setUserLocationCode("");
            setUserLocationDescription("");
            setModel("");
            setManufacturer("");
            setSerialNo("");
            setAssetClassification("");
            setAssetNo({ label: '', value: '' });
            setTaskCode({ label: '', value: '' });
            setAssignee({ label: '', value: '' });
            setAgreedDate('');
            setNextDate('');
            setScheduledFrequency(1);
            setPeriod(periodOptionsRearrange?.find((item) => item.label === "Weeks"));
            setStatus(statusOptions?.find((item) => item?.default === true));

            setAssetOptions(resultArray);
            handleServiceType(serviceType);
          }
        }
      }
      catch (e) {
        console.log(e)
      }
      finally {
        if (location.state.mode === "create") {
          setLoading(false);
        }
      }
    }

    if (serviceType?.label != '') {
      fetchOptions();
    }
  }, [serviceType]);


  const getTaskCode = useMemo(() => {
    const fetchOptionsForEdit = async () => {
      try {

        //  setLoading(true);
        if (serviceType?.label === 'BEMS') {
          const taskCodes = await PremitiveMaintenanceRepository.getBemsTaskCodeDetails(
            facilityId,
            assetNo?.workgroupdetailsId
          );
          setTaskCodeOptions(taskCodes);
          const assigneeList = await PremitiveMaintenanceRepository.getStaffDetails(facilityId);
          setAssigneeOptions(assigneeList);
          const dropDownLists =
            await PpmPlannerRepository.ppmscheduleDropDownList(
              facilityId,
              companyId
            );
          const periodOptionsRearrange = await ReArrangeLabels(
            dropDownLists?.data?.femppmintervaltypes,
            "intervaltypedesc",
            "label"
          );
          setPeriodOptions(periodOptionsRearrange?.filter((item) => (item.label === "Weeks" || item.label === "Months")));
          if (location.state.mode === "edit" || location.state.mode === "view") {
            setPredictiveId(location?.state?.predictiveId);
            setTaskCode(taskCodes?.find((item) => item?.value === location?.state?.taskcode));
            taskCodeForShowSchedule(taskCodes?.find((item) => item?.label === location?.state?.taskcode)?.value);
            const assigneeList = await PremitiveMaintenanceRepository.getStaffDetails(facilityId);
            if (assigneeList && assigneeList?.status !== 'error') {
              setAssigneeOptions(assigneeList);
              setAssignee(assigneeList?.find((item) => item?.label === location?.state?.assignee))
            }
            setPeriod(periodOptionsRearrange?.find((item) => item?.label === location?.state?.intervaltype));

            setAssetTypeCode(assetNo?.typecode);
            setAssetTypeCodeDescription(assetNo?.typedescription);
            setUserLocationCode(assetNo?.locationcode);
            setUserLocationDescription(assetNo?.locationdesc);
            setManufacturer(assetNo?.manufacturer);
            setModel(assetNo?.model);
            setSerialNo(assetNo?.serialno);
            setAssetClassification(assetNo?.assetclassification);
          }
        }
        else if (serviceType?.label === 'FEMS') {
          const taskCodes = await PremitiveMaintenanceRepository.getTaskCodeDetails(
            facilityId,
            assetNo?.workgroupdetailsId
          );
          setTaskCodeOptions(taskCodes);
          const assigneeList = await PremitiveMaintenanceRepository.getStaffDetails(facilityId);
          setAssigneeOptions(assigneeList);
          const dropDownLists =
            await PpmPlannerRepository.ppmscheduleDropDownList(
              facilityId,
              companyId
            );
          const periodOptionsRearrange = await ReArrangeLabels(
            dropDownLists?.data?.femppmintervaltypes,
            "intervaltypedesc",
            "label"
          );
          setPeriodOptions(periodOptionsRearrange?.filter((item) => (item.label === "Weeks" || item.label === "Months")));
          if (location.state.mode === "edit" || location.state.mode === "view") {
            setPredictiveId(location?.state?.predictiveId);
            setTaskCode(taskCodes?.find((item) => item?.label === location?.state?.taskcode))
            taskCodeForShowSchedule(taskCodes?.find((item) => item?.label === location?.state?.taskcode)?.value);
            const assigneeList = await PremitiveMaintenanceRepository.getStaffDetails(facilityId);
            if (assigneeList && assigneeList?.status !== 'error') {
              setAssigneeOptions(assigneeList);
              setAssignee(assigneeList?.find((item) => item?.label === location?.state?.assignee))
            }
            setPeriod(periodOptionsRearrange?.find((item) => item?.label === location?.state?.intervaltype));



            setAssetTypeCode(assetNo?.typecode);
            setAssetTypeCodeDescription(assetNo?.typedescription);
            setUserLocationCode(assetNo?.locationcode);
            setUserLocationDescription(assetNo?.locationdesc);
            setManufacturer(assetNo?.manufacturer);
            setModel(assetNo?.model);
            setSerialNo(assetNo?.serialno);
            setAssetClassification(assetNo?.assetclassification);

          }
        }
      }
      catch (e) {
        console.log(e)
      }
      finally {
        setLoading(false);
        await new Promise((resolve) => setTimeout(resolve, 0)); // Allow React to render the loader before heavy work

      }
    }
    const fetchTaskCode = async () => {
      if (serviceType?.label === 'BEMS') {
        const taskCodes = await PremitiveMaintenanceRepository.getBemsTaskCodeDetails(
          facilityId,
          assetNo?.workgroupdetailsId
        );
        setTaskCodeOptions(taskCodes);
      } else if (serviceType?.label === 'FEMS') {
        const taskCodes = await PremitiveMaintenanceRepository.getTaskCodeDetails(
          facilityId,
          assetNo?.workgroupdetailsId
        );
        setTaskCodeOptions(taskCodes);
      }
    }
    if (assetNo?.label != '' && (location.state.mode === "edit" || location.state.mode === "view")) {
      fetchOptionsForEdit();
    } else if (assetNo?.label != '' && location.state.mode === "create") {
      fetchTaskCode();
    }
  }, [assetNo])



  const onChangeHandle = (value, type) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth(); //To get the current month

    const adjustDateToCurrentYearAndMonth = (date) => {
      let year = getYear(date); //To get the current Year
      let month = getMonth(date); //To get the Current the Month
      let day = getDate(date); // To the get the current date

      if (year < currentYear) {
        year = currentYear;
      }

      if (year === currentYear && month < currentMonth) {
        month = currentMonth;
      }

      date = new Date(year, month, day);
      return date;
    };

    if (period) {
      var periodForPpm = period?.label;
    };

    //Calculate the Next date based on the props
    const calculateNextDate = (startFromDate, frequencyUnit, intervalTypeDesc) => {
      if (!frequencyUnit || frequencyUnit <= 0) {
        return adjustDateToCurrentYearAndMonth(startFromDate);
      }
    
      // Normalize frequency type
      let normalizedFrequency = intervalTypeDesc.trim().toLowerCase();
      if (normalizedFrequency === "weeks") {
        normalizedFrequency = "weekly";
      }
    
      let nextDate = startFromDate;
      const currentDate = new Date();
    
      if (normalizedFrequency === "weekly") {
        do {
          nextDate = addWeeks(nextDate, frequencyUnit);
        } while (isBefore(nextDate, currentDate));
      } else if (normalizedFrequency === "months") {
        do {
          nextDate = addMonths(nextDate, frequencyUnit);
        } while (isBefore(nextDate, currentDate));
      }
    
      return adjustDateToCurrentYearAndMonth(nextDate);
    };

    if (type === "agreedDate") { //Once Agreed Date changed means set the nextdate
      let Tdate = parse(value, "dd/MM/yyyy", new Date());
      let scheduledFrequencyPeriod = scheduledFrequency || 0;

      let nextPPMDate = calculateNextDate(Tdate, scheduledFrequencyPeriod, periodForPpm);
      const formattedDate = format(nextPPMDate, "dd/MM/yyyy");
      setNextDate(formattedDate);
    } else if (type === "scheduledfrequency" && agreedDate) { //Once Scheduled Frequency changed means set the nextdate
      let Tdate = parse(agreedDate, "dd/MM/yyyy", new Date());
      let scheduledFrequencyPeriod = value || 0;

      let nextPPMDate = calculateNextDate(Tdate, scheduledFrequencyPeriod, periodForPpm);
      const formattedDate = format(nextPPMDate, "dd/MM/yyyy");
      setNextDate(formattedDate);
    } else if (type === "period" && agreedDate) { //Once Period changed means set the nextdate
      let Tdate = parse(agreedDate, "dd/MM/yyyy", new Date());
      let scheduledFrequencyPeriod = scheduledFrequency || 0;

      let nextPPMDate = calculateNextDate(Tdate, scheduledFrequencyPeriod, value?.value);
      const formattedDate = format(nextPPMDate, "dd/MM/yyyy");
      setNextDate(formattedDate);
    }
  };

  const setEmpty = async () => {
    setAssetNo({ label: '', value: '' });
    setTaskCode({ label: '', value: '' });
    setAssignee({ label: '', value: '' });
    setAssetTypeCode('');
    setAssetTypeCodeDescription('');
    setUserLocationCode('');
    setUserLocationDescription('');
    setAgreedDate('');
    setNextDate('');
  }
  const setDefault = async () => {
    // setIsChanged(false);
    await setEmpty();
    setManufacturer('');
    setModel('');
    setAssetClassification('');
    setSerialNo('');
    setServiceType(serviceTypeOptions?.find((item) => item?.label === "FEMS"));
    setStatus(statusOptions?.find((item) => item?.default === true))
    setYear(yearOptions?.find((item) => Number(item?.value) === new Date().getFullYear()));
    selectedYear(yearOptions?.find((item) => Number(item?.value) === new Date().getFullYear()));
    setScheduledFrequency(1);
    setPeriod(periodOptions?.find((item) => item.label === "Weeks"));
    setErrors((prevErrors) => ({ ...prevErrors, assetNo: "", status: "", serviceType: "", taskCode: "", typeCode: "", agreedDate: "", scheduledFrequency: "", period: "", assignee: "", year: "" }));
  }

  const handleAddNew = async () => {
    if (isChanged) {
      setIsAddNew(true);
      setCancelDialogOpen(true);
    } else {
      await setDefault();
    }
  };

  const handleCancel = () => {
    if (isChanged && !(location?.state?.mode === "view")) {
      setCancelDialogOpen(true);
    } else {
      navigate('/predictiveMaintenance');
    }
  };


  const handleCancelDialogConfirm = async () => {
    if (isAddNew) {
      setCancelDialogOpen(false);
      await setDefault();
      setIsAddNew(false);
      setIsChanged(false);

    } else {
      setCancelDialogOpen(false);
      setDefault();
      setIsChanged(false);
      navigate('/predictiveMaintenance', { replace: true });
    }
  };

  //OLD ONE
  const generateDates = (
    start,
    frequency,
    predictiveMaintenanceId,
    startFromDate,
    schFrequency,
    assigneename
  ) => {
    console.log("Starting date generation...");
    console.log("Start Date:", start);
    console.log("Frequency:", frequency);
    console.log("Schedule Frequency:", schFrequency);
    console.log("Start From Date:", startFromDate);

    const getCurrentDate = new Date();
    const currentYear = getCurrentDate.getFullYear();

    let initialDate = new Date(start);
    console.log("Parsed Initial Date:", initialDate);

    const endDate = new Date(currentYear, 11, 31);
    console.log("End Date (Year-End):", endDate);

    const datesArray = [];
    const originalDay = initialDate.getDate();
    console.log("Original Day of Month:", originalDay);

    let weekNumber = getWeek(initialDate);
    let schTrackYear = format(initialDate, "yyyy");

    let rows = serviceType?.label === "FEMS"
      ? {
        week: "",
        trackyear: "",
        agreeddate: "",
        targetdate: "",
        fempredictivemaintenanceId: predictiveMaintenanceId,
        femtaskdetailsId: taskCode?.id,
        isdeleted: false,
        staffid: assigneename,

      }
      : {
        week: "",
        trackyear: "",
        agreeddate: "",
        targetdate: "",
        bempredictivemaintenanceId: predictiveMaintenanceId,
        bemtaskdetailsId: taskCode?.id,
        isdeleted: false,
        staffid: assigneename,
      };

    let currentDate = initialDate;

    // Ensure the first date is always the selected start date
    if (currentDate >= new Date(start)) {
      // console.log("Adding First Date:", currentDate);
      datesArray.push({
        ...rows,
        targetdate: format(currentDate, "yyyy-MM-dd'T'HH:mm:ss"),
        week: weekNumber,
        trackyear: schTrackYear,
        startfromdate: start,
        agreedDate: start
      });
    }

    while (currentDate <= endDate) {
      // console.log("-------------------------------------");
      // console.log("Before Update - Current Date:", currentDate);

      if (frequency === "Months") {
        let nextMonth = addMonths(currentDate, schFrequency === 0 ? 1 : schFrequency);
        let lastDayOfMonth = endOfMonth(nextMonth).getDate();

        // console.log("Next Month:", nextMonth);
        // console.log("Last Day of Next Month:", lastDayOfMonth);

        if (originalDay > lastDayOfMonth) {
          currentDate = endOfMonth(nextMonth);
          //        console.log("Adjusted to Last Day of Month:", currentDate);
        } else {
          currentDate = new Date(nextMonth);
          currentDate.setDate(originalDay);
          //      console.log("Set to Original Day:", currentDate);
        }
      } else {
        currentDate = addWeeks(currentDate, schFrequency === 0 ? 1 : schFrequency);
        //  console.log("New Weekly Date:", currentDate);
      }

      if (currentDate <= endDate && currentDate >= new Date(start)) {
        //console.log("Adding Date:", currentDate);
        datesArray.push({
          ...rows,
          targetdate: format(currentDate, "yyyy-MM-dd'T'HH:mm:ss"),
          week: getWeek(currentDate),
          trackyear: format(currentDate, "yyyy"),
          startfromdate: start,
          agreedDate: start
        });
      }
    }

    console.log("Generated Dates:", datesArray);
    console.log("Date generation complete.");

    return datesArray;
  };





  const handleSave = async () => {
    try {
      // Parse the date string
      const parsedDate = parse(nextDate, 'dd/MM/yyyy', new Date());
      // Extract the year as a number
      const yearValue = getYear(parsedDate);
      const currentYear = new Date().getFullYear();

      const withoutTimeZoneNextPpm = parse(
        agreedDate,
        "dd/MM/yyyy",
        new Date()
      );
      const parsedTargetDate = startOfDay(withoutTimeZoneNextPpm);
      const finalAgreedDate = format(
        parsedTargetDate,
        "yyyy-MM-dd'T'HH:mm:ss"
      );
      const finalAgreedDate1 = format(
        parsedTargetDate,
        "yyyy/MM/dd HH:mm:ss"
      );

      const withoutTimeZone = parse(nextDate, "dd/MM/yyyy", new Date());
      const parsedNextPpmDate = startOfDay(withoutTimeZone);
      const finalNextDate = format(
        parsedNextPpmDate,
        "yyyy-MM-dd'T'HH:mm:ss"
      );
      const date = new Date(withoutTimeZoneNextPpm);
      // Get the week number
      const weekNumber = getWeek(date);
      if (location?.state?.mode === "edit" || location?.state?.mode === "create") {
        let response;
        const payload = serviceType?.label === 'FEMS' ? {
          assigneeid: assignee?.id,
          isactive: status?.value,
          frequencyunit: scheduledFrequency,
          maintyearid: year?.id,
          agreeddate: finalAgreedDate,
          targetdate: finalNextDate,
          femassetregisterId: assetNo?.assetId,
          femtaskdetailsId: taskCode?.id,
          femppmintervaltypeId: period?.id,
          fempredictivemaintenancetracks: [],
          isdeleted: false
        } : {
          assigneeid: assignee?.id,
          isactive: status?.value,
          frequencyunit: scheduledFrequency,
          maintyearid: year?.id,
          agreeddate: finalAgreedDate,
          targetdate: finalNextDate,
          bemassetregisterId: assetNo?.assetId,
          bemtaskdetailsId: taskCode?.id,
          bemppmintervaltypeId: period?.id,
          bempredictivemaintenancetracks: [],
          isdeleted: false
        }
        if ((isChanged && !preventSaveDuplicateRecord) || (location?.state?.schyear !== currentYear)) {
          if (isInputChanged?.statusChanged && !(isInputChanged?.frequencyDatePeriodChanged)) {
            response = location?.state?.mode === "create" ? serviceType?.label === 'FEMS' ? await PremitiveMaintenanceRepository.createPDM(payload) : await PremitiveMaintenanceRepository.createBemsPDM(payload) : serviceType?.label === 'FEMS' ? await PremitiveMaintenanceRepository.updatePDM({ ...payload, id: location?.state?.predictiveId }, location?.state?.predictiveId) : await PremitiveMaintenanceRepository.updateBemsPDM({ ...payload, id: location?.state?.predictiveId }, location?.state?.predictiveId);
            setPredictiveId(response?.data?.id);
            setOpenDialog(true);
          } else if (isInputChanged?.assigneeTaskCodeChanged && !(isInputChanged?.frequencyDatePeriodChanged)) {
            response = location?.state?.mode === "create" ? serviceType?.label === 'FEMS' ? await PremitiveMaintenanceRepository.createPDM(payload) : await PremitiveMaintenanceRepository.createBemsPDM(payload) : serviceType?.label === 'FEMS' ? await PremitiveMaintenanceRepository.updatePDM({ ...payload, id: location?.state?.predictiveId }, location?.state?.predictiveId) : await PremitiveMaintenanceRepository.updateBemsPDM({ ...payload, id: location?.state?.predictiveId }, location?.state?.predictiveId);
            // ADD ONE API
            await PremitiveMaintenanceRepository.updatePDMAssigneorTaskCode(location?.state?.predictiveId, assignee?.id, taskCode?.id, serviceType?.label);
            setPredictiveId(response?.data?.id);
            setOpenDialog(true);
          } else {
            response = location?.state?.mode === "create" ? serviceType?.label === 'FEMS' ? await PremitiveMaintenanceRepository.createPDM(payload) : await PremitiveMaintenanceRepository.createBemsPDM(payload) : serviceType?.label === 'FEMS' ? await PremitiveMaintenanceRepository.updatePDM({ ...payload, id: location?.state?.predictiveId }, location?.state?.predictiveId) : await PremitiveMaintenanceRepository.updateBemsPDM({ ...payload, id: location?.state?.predictiveId }, location?.state?.predictiveId);
            setPredictiveId(response?.data?.id);

            if (response.status >= 200 && response.status <= 204) {
              if (location?.state?.mode != "edit" && yearValue === Number(year?.value)) {
                const generatedDates = generateDates(
                  finalAgreedDate1,
                  period?.label,
                  response?.data?.id,
                  finalNextDate,
                  scheduledFrequency,
                  assignee?.id
                );

                if (generatedDates?.length > 0) {
                  const setTracks = generatedDates?.map(async (item) => {
                    const updatePpmScheduleTracks = serviceType?.label === 'FEMS' ?
                      await PremitiveMaintenanceRepository.addPDMscheduleTracks(item) : await PremitiveMaintenanceRepository.addBemsPDMscheduleTracks(item);
                    return updatePpmScheduleTracks;
                  });

                  const updatePpmScheduleTracksInsert = await Promise.all(
                    setTracks
                  );
                  const allStatusForInsert = updatePpmScheduleTracksInsert.every(
                    (result) => result.status <= 204
                  );
                  if (allStatusForInsert) {
                    // setSaveCount(1);
                    setOpenDialog(true);
                    setPreventSaveDuplicateRecord(true);
                    // onClose();
                  }
                }
              } else if (location?.state?.mode != "edit" && yearValue !== Number(year?.value)) {
                setOpenDialog(true);
              }
              else if (location?.state?.mode === "edit") {
              

                //Console.log("EDIT MODE");
                const currentYearString = currentYear.toString();
                //Console.log(currentYearString, "currentYearString");

                let isDeleteTracks = false;
                const isYearChanged = location?.state?.schyear !== currentYearString;
                if (isChanged || isYearChanged) {

                  // if(!isYearChanged){

                  const updatePpmScheduleTracks = serviceType?.label === 'FEMS' ?
                    await PremitiveMaintenanceRepository.removePdmScheduleTracks(
                      location?.state?.predictiveId
                    ) :
                    await PremitiveMaintenanceRepository.removeBemsPdmScheduleTracks(
                      location?.state?.predictiveId
                    );

                  if (updatePpmScheduleTracks.status <= 204) {
                    isDeleteTracks = true;
                  };
                  // };
                  //Console.log(isDeleteTracks, "isdeletetracks");
                  if (isDeleteTracks === true) {
                    const generatedDates = generateDates(
                      finalAgreedDate1,
                      period?.label,
                      response?.data?.id,
                      finalNextDate,
                      scheduledFrequency,
                      assignee?.id
                    );
                    const currentDate = new Date();
                    console.log("Current Date:", currentDate);
                    
                    // Ignore time portion by setting both dates to midnight
                    const startOfToday = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
                    
                    const filteredDates = generatedDates.filter(item => {
                        const itemDate = new Date(item.targetdate);
                        const startOfItemDate = new Date(itemDate.getFullYear(), itemDate.getMonth(), itemDate.getDate());
                    
                        return startOfItemDate >= startOfToday;
                    });
                    
                    console.log("Filtered Dates:", filteredDates);


                    if (filteredDates && yearValue === Number(year?.value)) {

                      const setTracks = filteredDates?.map(async (item) => {
                        const updatePpmScheduleTracks =
                          serviceType?.label === 'FEMS' ?
                            await PremitiveMaintenanceRepository.addPDMscheduleTracks(item) : await PremitiveMaintenanceRepository.addPDMscheduleTracks(item);
                        return updatePpmScheduleTracks;
                      });
                      const updatePpmScheduleTracksUpdate = await Promise.all(
                        setTracks
                      );
                      const allStatusForUpdate =
                        updatePpmScheduleTracksUpdate.every(
                          (result) => result.status <= 204
                        );
                      if (allStatusForUpdate) {
                        setOpenDialog(true);
                      }
                    }
                    else {
                      setLoading(false);
                      setOpenDialog(true);
                    }
                  }
                } else if (!isChanged) {
                  setOpenDialog(true);
                }

              }
            } else if (response.status === 401) {
              console.error("Unauthorized");
            }
            setLoading(false);
          }

        } else if (location?.state?.mode === "edit" && !isChanged) {
          setOpenDialog(true);
        } else if (location?.state?.mode === "create" && preventSaveDuplicateRecord) {
          setOpenDialog(true);
        }
      }
    } catch (error) {
      console.error(error)

    }

  }
  const handleSubmit = async () => {
    const newErrors = {};
    if (!serviceType) newErrors.serviceType = "Service Type is required";
    if (!year) newErrors.year = "Year is required";
    if (!taskCode?.label) newErrors.taskCode = "Task Code is required";
    if (!assetNo?.label) newErrors.assetNo = "Asset No is required";
    if (!assignee?.label) newErrors.assignee = "Assignee is required";
    if (!period?.label) newErrors.period = "Period is required";
    if (!status?.label) newErrors.status = "Status is required";
    if (scheduledFrequency == 0) newErrors.scheduledFrequency = "Scheduled Frequency should be greater than zero";
    if (!agreedDate) newErrors.agreedDate = "Agreed Date is required";
    if (Object.keys(newErrors)?.length > 0) {
      setErrors(newErrors);
    } else {
      await handleSave();
      setIsInputChanged((prev) => ({
        ...prev,
        assigneeTaskCodeChanged: false,
        frequencyDatePeriodChanged: false,
        statusChanged: false
      }));
    }
  };


  const handleCloseDialog = () => {
    // setOpenDialogForSelectedCombination(false);
    setOpenDialog(false);
    setIsAddNew(false);
    setIsChanged(false);
    setDisableUpdateButton(true);


  };
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleOpenModalForAsset = () => setIsModalOpenForAsset(true);
  const handleCloseModalForAsset = () => setIsModalOpenForAsset(false);

  return (
    <>
      <PageLoader open={loading} />
      <Box mt={{ xs: 1, sm: 2 }}>
        <DefaultCard>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Typography variant='h5'>Basic Details</Typography></Grid>

            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="service-type-label"
                label="Service Type"
                isMandatoryField={true}
                value={serviceType}
                autoFocus={true}
                options={serviceTypeOptions}
                errorMessage={errors.serviceType}
                error={!!errors.serviceType}
                onChange={(newValue) => {
                  setIsChanged(true);
                  setErrors({ ...errors, serviceType: "" });
                  setServiceType(newValue);
                }}
                disabled={location.state.mode === "view" || location.state.mode === "edit"}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="year-label"
                label="Year"
                isMandatoryField={true}
                value={year}
                errorMessage={errors.year}
                error={!!errors.year}
                options={yearOptions}
                onChange={(newValue) => {

                  setErrors({ ...errors, year: "" });
                  setYear(newValue);
                  selectedYear(newValue);
                }}
                disabled={location.state.mode === "view"}
              />
            </Grid>
            <Grid item xs={(location.state.mode === "view") ? 12 : 11.5} md={(location.state.mode === "view") ? 4 : 3.5} sm={(location.state.mode === "view") ? 6 : 5.5}>
              <CustomTextFieldWithSearch
                // autoFocus={true}
                isMandatoryField={true}
                label="Asset No."
                id="assetno"
                value={assetNo}
                error={!!errors?.assetNo}
                errorMessage={errors.assetNo}
                options={assetOptions?.map(option => ({
                  ...option,
                  label: `${option.label} - ${option.assetdesc}`,
                }))?.sort((a, b) => a.label.localeCompare(b.label))
                }
                onChange={(newValue) => {
                  let label = newValue?.label?.split(" - ")[0];
                  setAssetNo({ ...newValue, label: label });
                  setIsChanged(true);

                  if (newValue?.value === "") {
                    setAssetTypeCode("");
                    setAssetTypeCodeDescription("");
                    setUserLocationCode("");
                    setUserLocationDescription("");
                    setModel("");
                    setManufacturer("");
                    setSerialNo("");
                    setAssetClassification("");
                  } else if (newValue?.label !== "") {
                    setAssetTypeCode(newValue?.typecode);
                    setAssetTypeCodeDescription(newValue?.typedescription);
                    setUserLocationCode(newValue?.locationcode);
                    setUserLocationDescription(newValue?.locationdesc);
                    setManufacturer(newValue?.manufacturer);
                    setModel(newValue?.model);
                    setSerialNo(newValue?.serialno);
                    setAssetClassification(newValue?.assetclassification);
                    assetNoForShowSchedule({ ...newValue, label: newValue?.value });
                    setErrors({ ...errors, assetNo: null });

                  }
                }}
                disabled={location.state.mode === "view" || location.state.mode === "edit"}
              />
            </Grid>

            {(location.state.mode != "view") && (<Grid item xs={0.5} md={0.5} sm={0.5} >
              {location.state.mode != "view" && (
                <Grid sx={{ mt: 2.7 }} item>
                  <Button
                    onClick={handleOpenModalForAsset}
                    variant="contained"
                    sx={{ minWidth: '32px', minHeight: '32px', marginLeft: '0rem' }}
                    disabled={location.state.mode === "view" || location.state.mode === "edit"}>
                    <SearchIcon fontSize="small" />
                  </Button>
                </Grid>
              )}

              <Dialog
                open={isModalOpenForAsset}
                onClose={(event, reason) => {
                  if (reason === "backdropClick") {
                    return; // Prevent closing on backdrop click
                  }
                  handleCloseModalForAsset(); // Call the close function for other reasons
                }}
                // onClose={handleCloseModal}
                aria-labelledby="asset-grid-dialog"
                aria-describedby="grid-display-for-assets"
                maxWidth="lg"
                fullWidth
              ><DialogTitle
                id="asset-grid-dialog"
                sx={{
                  fontWeight: 'bold',
                  fontSize: '1.5rem', // Adjust font size as desired
                  display: 'flex',
                  justifyContent: 'space-between', // Space out title and icon
                  alignItems: 'center',
                }}
              >
                  Asset Search
                  <IconButton
                    aria-label="close"
                    variant="outlined"
                    onClick={handleCloseModalForAsset}
                    sx={{
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent
                  dividers
                  sx={{
                    overflowY: 'auto', // Enables scroll if content overflows
                    height: 'auto',    // Allows height to adjust based on content
                    maxHeight: 'auto', // Sets a maximum height to prevent it from growing too large
                  }}
                >
                  <CustomAgGrid
                    rows={assetOptions || []}
                    columns={columns}
                    // loading={loadingAssets}
                    refSet={gridApi}
                    setGridApi={setGridApi}
                  />
                  <Stack my={3} direction={"row"} justifyContent={"end"}>
                    <Button variant="outlined" onClick={handleCloseModalForAsset}>
                      Close
                    </Button>
                  </Stack>
                </DialogContent>
              </Dialog>

            </Grid>
            )}
            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="Asset Type Code"
                id="assettypecode"
                value={assetTypeCode}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="Asset Type Code Description"
                id="assettypecodedescription"
                value={assetTypeCodeDescription}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="User Location Code"
                id="userlocationcode"
                value={userLocationCode}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="User Location Description"
                id="userlocationdesc"
                value={userLocationDescription}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="Model"
                id="model"
                value={model}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="Manufacturer"
                id="pdmNo"
                value={manufacturer}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="Serial No."
                id="serialno"
                value={serialNo}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="Asset Classification"
                id="assetClassification"
                value={assetClassification}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextFieldWithSearch
                label="Assignee"
                id="asset-no"
                value={assignee}
                options={assigneeOptions?.map(option => ({
                  ...option,
                  label: `${option?.employeecode}-${option?.label}`,

                }))?.sort((a, b) => a.label.localeCompare(b.label))
                }
                onChange={(newValue) => {
                  setAssignee(newValue?.value !== '' ? { ...newValue, label: newValue.value } : '');
                  if (newValue?.label !== "") {
                    setErrors({ ...errors, assignee: null });
                    setIsChanged(true);
                    setIsInputChanged((prev) => ({
                      ...prev,
                      assigneeTaskCodeChanged: true
                    }));

                  }
                }}
                isMandatoryField={true}
                error={errors.assignee}
                errorMessage={errors.assignee}
                disabled={location.state.mode === "view"}
              />
            </Grid>
            <Grid item xs={(location.state.mode == "view") ? 12 : 11.5} md={(location.state.mode == "view") ? 4 : 3.5} sm={(location.state.mode == "view") ? 6 : 5.5} >
              <CustomTextFieldWithSearch
                isMandatoryField={true}
                error={!!errors?.taskCode}
                errorMessage={errors.taskCode}
                label="Task Code"
                id="tc-no"
                value={taskCode}
                options={taskCodeOptions?.map(option => ({
                  ...option,
                  label: `${option.label} - ${option.taskdesc}`,
                  value: option.value,
                  assetdesc: option?.assetdesc,
                  id: option?.id
                }))?.sort((a, b) => a.label.localeCompare(b.label))
                }
                onChange={(newValue) => {

                  setTaskCode({ ...newValue, label: newValue?.value });
                  setIsChanged(true);
                  if (newValue?.label !== "") {
                    taskCodeForShowSchedule(newValue?.value);
                    setErrors({ ...errors, taskCode: null });
                    setIsInputChanged((prev) => ({
                      ...prev,
                      assigneeTaskCodeChanged: true
                    }));
                  }
                }}
                disabled={location.state.mode === "view"}
              />
            </Grid>

            {(location.state.mode != "view") && (<Grid item xs={0.5} md={0.5} sm={0.5} >
              {location.state.mode != "view" && (
                <Grid sx={{ mt: 2.7 }} item>
                  <Button
                    onClick={handleOpenModal}
                    variant="contained"
                    sx={{ minWidth: '32px', minHeight: '32px', marginLeft: '0rem' }}
                    disabled={location.state.mode == "view"}>
                    <SearchIcon fontSize="small" />
                  </Button>
                </Grid>
              )}

              <Dialog
                open={isModalOpen}
                onClose={(event, reason) => {
                  if (reason === "backdropClick") {
                    return; // Prevent closing on backdrop click
                  }
                  handleCloseModal(); // Call the close function for other reasons
                }}
                aria-labelledby="asset-grid-dialog"
                aria-describedby="grid-display-for-assets"
                maxWidth="lg"
                fullWidth
              ><DialogTitle
                id="asset-grid-dialog"
                sx={{
                  fontWeight: 'bold',
                  fontSize: '1.5rem', // Adjust font size as desired
                  display: 'flex',
                  justifyContent: 'space-between', // Space out title and icon
                  alignItems: 'center',
                }}
              >
                  Task Code Search
                  <IconButton
                    aria-label="close"
                    variant="outlined"
                    onClick={handleCloseModal}
                    sx={{
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent
                  dividers
                  sx={{
                    overflowY: 'auto', // Enables scroll if content overflows
                    height: 'auto',    // Allows height to adjust based on content
                    maxHeight: 'auto', // Sets a maximum height to prevent it from growing too large
                  }}
                >
                  <CustomAgGrid
                    rows={taskCodeOptions || []}
                    columns={columnsTaskCode}
                    // loading={loadingAssets}
                    refSet={gridAPIS}
                    setGridApi={setGridAPIS}
                  />
                  <Stack my={3} direction={"row"} justifyContent={"end"}>
                    <Button variant="outlined" onClick={handleCloseModal}>
                      Close
                    </Button>
                  </Stack>
                </DialogContent>
              </Dialog>

            </Grid>)}
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                label="Period"
                isMandatoryField={true}
                value={period}
                error={!!errors?.period}
                errorMessage={errors.period}
                options={periodOptions || []}
                onChange={(newValue) => {
                  setIsChanged(true);
                  onChangeHandle(newValue, "period");
                  setIsInputChanged((prev) => ({
                    ...prev,
                    frequencyDatePeriodChanged: true
                  }));
                  //  setIsFilledAllMandatoryField(false);
                  setPeriod(newValue);
                  if (newValue?.label !== "") {
                    setErrors({ ...errors, period: null });
                  }
                }}
                disabled={location.state.mode === "view"}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                onlyNumbers={true}
                isMandatoryField={true}
                id="schdulefrequency"
                label="Schedule Frequency"
                value={scheduledFrequency}
                error={!!errors?.scheduledFrequency}
                errorMessage={errors.scheduledFrequency}
                onChange={(newValue) => {
                  onChangeHandle(Number(newValue) + 0, "scheduledfrequency");
                  // setIsFilledAllMandatoryField(false);
                  setScheduledFrequency(Number(newValue) + 0);
                  if (newValue !== "") {
                    setIsChanged(true);
                    setErrors({ ...errors, scheduledFrequency: null });
                    setIsInputChanged((prev) => ({
                      ...prev,
                      frequencyDatePeriodChanged: true
                    }));
                  }
                  //scheduledFrequencyRef.current = newValue
                }}
                disabled={location.state.mode === "view"}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="status"
                label="Status"
                isMandatoryField={true}
                value={status}
                options={statusOptions}
                errorMessage={errors.status}
                error={!!errors.status}
                onChange={(newValue) => {
                  if (newValue?.label != '') {
                    setIsChanged(true);
                    setErrors({ ...errors, status: "" });
                    setIsInputChanged((prev) => ({
                      ...prev,
                      statusChanged: true
                    }));
                  }
                  setStatus(newValue);
                }}
                disabled={location.state.mode === "view"}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomDatePicker
                label="Agreed Date"
                isStatrtDate={true}
                dissablePastDate={true}
                id={"agreed-date"}
                //   modal={open}
                isMandatoryField={true}
                value={agreedDate}
                error={!!errors?.agreedDate}
                errorMessage={errors.agreedDate}
                onDateChange={(newValue) => {
                  onChangeHandle(newValue, "agreedDate");
                  setAgreedDate(newValue);
                  setIsChanged(true);
                  setIsInputChanged((prev) => ({
                    ...prev,
                    frequencyDatePeriodChanged: true
                  }));
                  setErrors({ ...errors, agreedDate: null });
                }}
                disabled={location.state.mode === "view"}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                maxlength={225}
                label="Next Date"
                id="nextDate"
                value={nextDate}
                disabled={true}
              />
            </Grid>

          </Grid>

          <Box
            sx={{
              marginTop: "30px",
              display: "flex",
              gap: 2,
              justifyContent: { xs: "center", md: "end" },
            }}
          >


            <ActionButtons
              handleSubmit={handleSubmit}
              handleCancel={handleCancel}
              handleAddNew={handleAddNew}
              enableSubmit={!disableUpdateButton}
              isEdit={location.state.mode === "edit"}
              isView={location.state.mode === "view"}
              updateLabel={((location.state.changeHeaderAndButtonName === false) || (location.state.mode === "edit")) ? "Update" : "Save"}
              SaveLabel={"Save"}
            />
          </Box></DefaultCard></Box>
      <CustomDialog
        open={cancelDialogOpen}
        onClose={() => setCancelDialogOpen(false)}
        title="Unsaved Changes"
        content="Record(s) not Saved/Updated. Do you want to continue?"
        confirmBtn="Yes"
        cancelBtn="No"
        onConfirm={handleCancelDialogConfirm}
        onCancel={() => setCancelDialogOpen(false)}
      />
      <CustomDialog
        open={openDialog}
        onClose={handleCloseDialog}
        // title="Unsaved Changes"
        content={location?.state.mode !== "edit" ? "Data saved successfully." : "Data updated successfully."}
        confirmBtn={"OK"}

        onConfirm={handleCloseDialog}
      />
    </>
  )
};
export default PDMCreate






